import { Injectable } from '@angular/core';
import { ProcessDesignerUIState } from './process-designer.uistate';
import { ElementPropertyConfig, PropertyEntity } from '@farris/ide-property-panel';
import { KeyMap } from '@farris/ide-property-panel';
import { ProcessListHelpComponent } from '../views/aif-process-list-help/components/process-list-help/process-list-help.component';
import { AifCreationBillProcessConverter } from '../views/aif-process-list-help/AifCreationBillProcessConverter';
import { SequenceFlowPropertyKeys } from '../designer/wf-cell/property-keys/SequenceFlowPropertyKeys';
import { AifLocalePipe } from '../views/aif-ui-common/pipe/aif-ui-common-locale.pipe';

@Injectable()
export class SequenceActivityAdapter {
    constructor(
        private uiState: ProcessDesignerUIState,
        public localePipe: AifLocalePipe
        ) {

    }
    setProperty(obj: any) {
        this.uiState.propertyData = obj.propertyData;
        this.uiState.propertyConfig = this.setConfig(obj.propertyConfig);
    }

    private setConfig(obj: any[]): ElementPropertyConfig[] {
        const propertyConfig: ElementPropertyConfig[] = [];
        if (obj) {
            obj.forEach((element: ElementPropertyConfig) => {
                this.setEntity(element.properties);
                propertyConfig.push(element);
            });
        }
        return propertyConfig;
    }
    private setEntity(obj: PropertyEntity[]) {
        if (obj && obj.length > 0) {
            obj.forEach((item: PropertyEntity) => {
                switch (item.propertyID) {
                    case SequenceFlowPropertyKeys.billCreationType:
                        item.iterator = billCreationTypeKeyMap;
                        break;
                    case SequenceFlowPropertyKeys.billRelationType:
                        item.iterator = billRelationTypeKeyMap;
                        break;
                    case SequenceFlowPropertyKeys.aifAutoProcessCode:
                        item.editor = ProcessListHelpComponent;
                        item.converter = new AifCreationBillProcessConverter(this.localePipe);
                        item.editorParams = {
                            bizTypeId: this.uiState.flowFormInfo.flowForm.businessObjectId
                        };
                        break;
                    case SequenceFlowPropertyKeys.aifPushProcessCode:
                        item.editor = ProcessListHelpComponent;
                        item.converter = new AifCreationBillProcessConverter(this.localePipe);
                        item.editorParams = {
                            bizTypeId: this.uiState.flowFormInfo.flowForm.businessObjectId
                        };
                        break;
                    case SequenceFlowPropertyKeys.aifPullProcessCode:
                        item.editor = ProcessListHelpComponent;
                        item.converter = new AifCreationBillProcessConverter(this.localePipe);
                        item.editorParams = {
                            bizTypeId: this.uiState.flowFormInfo.flowForm.businessObjectId
                        };
                        break;
                    default:
                        break;
                }
            });
        }
    }
}

export const billCreationTypeKeyMap: KeyMap[] = [
    { key: "AUTO", value: "自动生单" },
    { key: "PUSH", value: "推式生单" },
    { key: "PULL", value: "拉式生单" },
];

export const billRelationTypeKeyMap: KeyMap[] = [
    { key: "CREATION", value: "通过生单流程生成目标单" },
    // { key: "EXPRESSION", value: "通过表达式获取目标单" },
];